export const STORE_ROOT = 'store';
export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const TEMPLATE_SELECTED = 'TEMPLATE_SELECTED';
export const USER_UPDATED = 'USER_UPDATED';
